import { semaphore, commands } from '../flutter/flutter2-semaphore';
import { invokeFlutterService } from '@/utils/flutter/flutter-service';

/** @type {(text: string, subject: string, url: string) => Promise<void>} */
export const share = async (text = "", subject = "", url = "") => {
    let shareSucceed = false;

    if ('SemaphoreJavascriptChannel' in window) {
        semaphore({
            name: commands.share.command,
            data: {
              text: text + url,
              subject,
            },
          })
        shareSucceed = true;
    } else {
        shareSucceed = invokeFlutterService('FlutterShareService', JSON.stringify({ text: text + url, subject }));
    }

    // If sharing was successfully, do not use browser's Share API.
    if (shareSucceed) return;

    // Check sharing is resolved by mobile os, if it did not then try browser's Share API.
    // @ts-ignore
    if (!('share' in navigator)) return app.$bus.$emit(
        'app.showSnackbar',
        { text: 'Sharing is not available in this device.' }
    );

    try {
        await navigator.share({ title: text, url });
    } catch (error) {
        captureException(error);
    }
}
